// Shared FAQ content (landing accordion + /faq page).
export const FAQS = [
  {
    q: "Che cos'è StayGuide?",
    a: "StayGuide ti permette di creare una guida digitale per i tuoi ospiti: check-in, Wi-Fi, regole della casa, consigli locali, come muoversi e un Concierge AI. Gli ospiti la aprono da un semplice link o QR code, senza scaricare nulla.",
  },
  {
    q: "Gli ospiti devono scaricare un'app?",
    a: "No. La guida è una pagina web ottimizzata per smartphone. Basta condividere il link o mostrare il QR code: si apre immediatamente nel browser.",
  },
  {
    q: "Come funziona la prova gratuita?",
    a: "Hai 7 giorni di prova gratuita con 1 struttura, guida completa, QR code e funzionalità AI limitate. Non serve la carta di credito per iniziare e non c'è alcun impegno.",
  },
  {
    q: "Come funziona il Concierge AI?",
    a: "Il Concierge AI risponde alle domande degli ospiti usando esclusivamente le informazioni presenti nella tua guida. Non inventa dati: se un'informazione non c'è, invita l'ospite a contattarti.",
  },
  {
    q: "Il modulo «Come muoversi» inventa orari o percorsi?",
    a: "No. Mostriamo una mappa reale e apriamo Google Maps per indicazioni e orari in tempo reale. Non generiamo automaticamente fermate, linee o orari: i dati provengono sempre da fonti reali.",
  },
  {
    q: "Posso gestire più strutture?",
    a: "Sì. Il piano Pro include fino a 3 strutture e il piano Business fino a 10, con gestione centralizzata da un unico account.",
  },
  {
    q: "Come funzionano i pagamenti e posso annullare?",
    a: "I pagamenti sono gestiti in modo sicuro tramite Stripe. L'abbonamento si rinnova automaticamente (mensile o annuale) e puoi annullarlo quando vuoi: continuerai ad avere accesso fino alla fine del periodo pagato.",
  },
  {
    q: "In quali lingue è disponibile la guida?",
    a: "L'interfaccia è in italiano e la guida per gli ospiti supporta la traduzione AI (italiano/inglese) nei piani a pagamento, così i tuoi ospiti internazionali si sentono a casa.",
  },
  {
    q: "Cosa succede quando finisce la prova?",
    a: "Al termine dei 7 giorni le guide pubbliche vengono messe in pausa finché non scegli un piano. I tuoi contenuti restano salvati e tornano online immediatamente dopo l'attivazione.",
  },
  {
    q: "I dati miei e dei miei ospiti sono al sicuro?",
    a: "Sì. Trattiamo i dati nel rispetto del GDPR (Reg. UE 2016/679). Le password sono cifrate, non conserviamo i dati delle carte (gestiti da Stripe) e puoi esercitare i tuoi diritti in qualsiasi momento. Consulta la nostra Privacy Policy per i dettagli.",
  },
];
